import moment from 'moment';
import * as actionTypes from './actionTypes';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const axiosPayLoad = {
  loginUseRole: null,
  checkSearchResults: [],
  saveCheckValues: {},
  deleteCheckValues: {},
  getAllLastUserIds: [],
  generalSystemParameter: [],
  checkSearchRequestData: {},
  checkSearchFormErrorData: {},
  checkSearchErrorMessage: [],
  maintainCheckRequestData: {},
  maintainCheckFormErrorData: {},
  maintainCheckErrorMessage: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_ROLE:
      return { ...state, loginUseRole: action.loginUseRole };
    case actionTypes.SEARCH_CHECK_VALUES:
      if (
        action.checkSearchValues &&
        action.checkSearchValues.error !== 'API failed'
      ) {
        action.checkSearchValues &&
          action.checkSearchValues.forEach((item, i) => {
            item.index = i;
            item.batchDt = item.batchDt
              ? moment(
                  new Date(
                    new Date(item.batchDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
            item.checkDt = item.checkDt
              ? moment(
                  new Date(
                    new Date(item.checkDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
            item.postmarkedDt = item.postmarkedDt
              ? moment(
                  new Date(
                    new Date(item.postmarkedDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
            item.receivedDt = item.receivedDt
              ? moment(
                  new Date(
                    new Date(item.receivedDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
            item.suspendedDt = item.suspendedDt
              ? moment(
                  new Date(
                    new Date(item.suspendedDt).toLocaleString('en-US', {
                      timeZone: process.env.REACT_APP_TIMEZONE,
                    })
                  )
                ).format('MM/DD/YYYY')
              : null;
            if (!item.totAllocatedAmt?.toString()?.includes('$'))
              item.totAllocatedAmt = item.totAllocatedAmt
                ? handleCommaSeparatedAmount(item.totAllocatedAmt)
                : `$ ${parseFloat(0).toFixed(2)}`;
            if (!item.checkAmt?.toString()?.includes('$'))
              item.checkAmt = item.checkAmt
                ? handleCommaSeparatedAmount(item.checkAmt)
                : `$ ${parseFloat(0).toFixed(2)}`;
          });
      }

      return {
        ...state,
        checkSearchResults: action?.checkSearchValues.map((item) => {
          item.checkPayeeCdVal = item.checkPayeeCd;
          item.batchDt = item.batchDt
            ? moment(item?.batchDt).format('MM/DD/YYYY')
            : null;
          item.checkDt = item.checkDt
            ? moment(item?.checkDt).format('MM/DD/YYYY')
            : null;
          item.postmarkedDt = item.postmarkedDt
            ? moment(item?.postmarkedDt).format('MM/DD/YYYY')
            : null;
          item.receivedDt = item.receivedDt
            ? moment(item?.receivedDt).format('MM/DD/YYYY')
            : null;
          if (!item.totAllocatedAmt?.toString()?.includes('$'))
            item.totAllocatedAmt = item.totAllocatedAmt
              ? handleCommaSeparatedAmount(item.totAllocatedAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
          if (!item.checkAmt?.toString()?.includes('$'))
            item.checkAmt = item.checkAmt
              ? handleCommaSeparatedAmount(item.checkAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
          return item;
        }),
      };
    case actionTypes.SAVE_CHECK_VALUES:
      return { ...state, saveCheckValues: action.saveCheckValues };
    case actionTypes.DELETE_CHECK_VALUES:
      return { ...state, deleteCheckValues: action.deleteCheckValues };
    case actionTypes.ALL_LAST_UPDATED_USER_ID:
      return { ...state, getAllLastUserIds: action.getAllLastUserIds };
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER_CHECK: {
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    }

    case actionTypes.COMMON_COMMENTS_DATA:
      return { ...state, commonCommentsData: action.payload };
    case actionTypes.GET_LINK_TABLE_DATA:
      return { ...state, commentsLinkData: action.payload };
    case 'SEARCH_CHECK_REQUEST': {
      return { ...state, checkSearchRequestData: action.payload };
    }
    case 'SEARCH_CHECK_ERROR_REQUEST': {
      return { ...state, checkSearchFormErrorData: action.payload };
    }
    case 'SEARCH_CHECK_ERROR_MESSAGE': {
      return { ...state, checkSearchErrorMessage: action.payload };
    }
    case 'MAINTAIN_CHECK_REQUEST': {
      return { ...state, maintainCheckRequestData: action.payload };
    }
    case 'MAINTAIN_CHECK_ERROR_REQUEST': {
      return { ...state, maintainCheckFormErrorData: action.payload };
    }
    case 'MAINTAIN_CHECK_ERROR_MESSAGE': {
      return { ...state, maintainCheckErrorMessage: action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
